export { default as Img200 } from './processed/200/InglouriousBasterds.jpg';
export { default as Img400 } from './processed/400/InglouriousBasterds.jpg';
export { default as Imgthumb } from './processed/thumb/InglouriousBasterds.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/InglouriousBasterds.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/InglouriousBasterds.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      203,
      44,
      45
    ],
    "_population": 1497,
    "_hsl": [
      0.9989517819706499,
      0.6437246963562754,
      0.484313725490196
    ]
  },
  "LightVibrant": {
    "_rgb": [
      231,
      166,
      121
    ],
    "_population": 402,
    "_hsl": [
      0.06818181818181819,
      0.6962025316455696,
      0.6901960784313725
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      112,
      13,
      11
    ],
    "_population": 1325,
    "_hsl": [
      0.0033003300330033004,
      0.8211382113821137,
      0.2411764705882353
    ]
  },
  "Muted": {
    "_rgb": [
      136,
      114,
      101
    ],
    "_population": 1344,
    "_hsl": [
      0.061904761904761955,
      0.14767932489451477,
      0.4647058823529412
    ]
  },
  "LightMuted": {
    "_rgb": [
      184,
      147,
      148
    ],
    "_population": 25,
    "_hsl": [
      0.9954954954954953,
      0.2067039106145252,
      0.6490196078431372
    ]
  },
  "DarkMuted": {
    "_rgb": [
      52,
      31,
      28
    ],
    "_population": 428,
    "_hsl": [
      0.020833333333333332,
      0.3,
      0.1568627450980392
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/InglouriousBasterds.js